{
  "panel": {
    "title": "Shënimet",
    "newNote_title": "Shënim i ri",
    "search_placeholder": "Kërko në shënime…",
    "search_aria": "Kërko në shënime",
    "clearSearch_aria": "Pastro kërkimin",
    "editorPlaceholder": "Çfarë ke ndërmend…",
    "titleInput_placeholder": "Pa titull",
    "untitled": "Pa titull",
    "emptyNote": "Shënim bosh",
    "loadingNotes": "Duke ngarkuar shënimet…",
    "noNotesYet": "Ende pa shënime. Trokit + për të krijuar një.",
    "noResults": "Asnjë rezultat për \"{{query}}\"",
    "noNotesTagged": "Asnjë shënim me etiketën {{tag}}",
    "tagFilterAll": "Të gjitha",
    "filterByTag_aria": "Filtro sipas etiketës",
    "templates": "Modelet",
    "editorTheme_aria": "Tema e redaktorit",
    "themeActive_aria": "Tema {{theme}} (aktive)",
    "theme_aria": "Tema {{theme}}",
    "themeName": {
      "dark": "E errët",
      "sepia": "Sepia",
      "light": "E ndritshme",
      "forest": "Pyll"
    },
    "voice": "Zëri",
    "voice_title": "Shënim zanor",
    "voiceUnavailable_title": "Të folurit i padisponueshëm në këtë shfletues",
    "openVoiceRecorder_aria": "Hap regjistruesin e shënimit zanor",
    "summarizing_title": "Duke përmbledhur…",
    "summarize_title": "Përmblidh",
    "summarizeNote_aria": "Përmblidh shënimin",
    "aiCommands_title": "Komandat AI  Cmd+K",
    "openAiPalette_aria": "Hap paletën e komandave AI",
    "enterFocusMode_title": "Modaliteti i fokusit  Cmd+Shift+F",
    "exitFocusMode_title": "Dil nga modaliteti i fokusit  Cmd+Shift+F",
    "enterFocusMode_aria": "Hyr në modalitetin e fokusit",
    "exitFocusMode_aria": "Dil nga modaliteti i fokusit",
    "export_title": "Eksporto shënimin",
    "delete_title": "Fshij shënimin",
    "delete_aria": "Fshij shënimin",
    "moreActions_title": "Më shumë veprime",
    "wordCount_one": "{{formatted}} fjalë · ~{{minutes}} min lexim",
    "wordCount_other": "{{formatted}} fjalë · ~{{minutes}} min lexim",
    "referencedBy_one": "Referuar nga {{count}}",
    "referencedBy_other": "Referuar nga {{count}}",
    "noMatchingNotes": "Asnjë shënim përputhës",
    "mobileTabs_aria": "Pamja e shënimeve",
    "mobileTabNotes": "Shënimet",
    "mobileTabEditor": "Redaktori",
    "saveFailed": "Dështoi ruajtja e shënimit: {{message}}",
    "deleteFailed": "Dështoi fshirja e shënimit",
    "loadFailed": "Dështoi ngarkimi i shënimeve",
    "analyzeFailed": "Dështoi analizimi i shënimit",
    "aiCommandFailed": "Komanda AI dështoi",
    "unknownError": "Gabim i panjohur"
  },
  "paywall": {
    "title": "Shënimet janë pjesë e Rhemn Pro",
    "safariBody": "Unlock synced notes, dictation, and AI summaries with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "body": "Zhblloko shënimet e sinkronizuara, diktimin në shfletues dhe përmbledhjet AI të strukturuara."
  },
  "format": {
    "bold": "Trash",
    "italic": "Pjerrët",
    "strikethrough": "Vijëzuar",
    "inlineCode": "Kod në rresht",
    "heading1": "Titull 1",
    "heading2": "Titull 2",
    "heading3": "Titull 3",
    "bulletList": "Listë me pika",
    "numberedList": "Listë e numëruar",
    "blockquote": "Citim",
    "codeBlock": "Bllok kodi",
    "toggleBold_aria": "Ndërro trashin",
    "toggleItalic_aria": "Ndërro të pjerrëtin",
    "toggleStrikethrough_aria": "Ndërro vijëzimin",
    "toggleInlineCode_aria": "Ndërro kodin në rresht",
    "toggleBulletList_aria": "Ndërro listën me pika",
    "toggleNumberedList_aria": "Ndërro listën e numëruar",
    "toggleBlockquote_aria": "Ndërro citimin",
    "formatOptions_aria": "Opsionet e formatimit"
  },
  "analysis": {
    "heading": "Përmbledhje",
    "onDevice": "⚡ Në pajisje",
    "onDevice_aria": "Përpunuar në pajisje",
    "applyToNote_title": "Zbato te shënimi",
    "applyToNote_aria": "Zbato përmbledhjen te shënimi",
    "summaryLabel": "Përmbledhje",
    "keyPointsLabel": "Pikat Kryesore",
    "noKeyPoints": "Nuk u kthye asnjë pikë kryesore për këtë shënim."
  },
  "export": {
    "markdown": "Eksporto si Markdown",
    "plainText": "Eksporto si Tekst i Thjeshtë",
    "pdf": "Eksporto si PDF",
    "allZip": "Eksporto të gjitha si ZIP",
    "label": "Eksporto"
  },
  "cmdk": {
    "dialog_aria": "Paleta e komandave AI",
    "input_placeholder": "Pyet AI-në ose ekzekuto një komandë…",
    "esc": "Esc",
    "back_aria": "Mbrapa",
    "translateTo": "Përkthe në",
    "language_placeholder": "Gjuha…",
    "aiActions": "Veprimet AI",
    "noCommandsMatch": "Asnjë komandë nuk përputhet me \"{{query}}\"",
    "continue": {
      "label": "Vazhdo të shkruash",
      "description": "Vazhdo nga aty ku e le"
    },
    "summarize": {
      "label": "Përmblidh përzgjedhjen",
      "description": "Ngjesh në pika kryesore"
    },
    "formal": {
      "label": "Bëje këtë formale",
      "description": "Ngrije tonin në profesional"
    },
    "simplify": {
      "label": "Thjeshto",
      "description": "Gjuhë më e shkurtër, më e qartë"
    },
    "translate": {
      "label": "Përkthe në…",
      "description": "Përkthe në një gjuhë tjetër"
    },
    "expand": {
      "label": "Zgjero këtë pikë",
      "description": "Rrite pikën e zgjedhur në prozë"
    },
    "languages": {
      "Spanish": "Spanjisht",
      "Arabic": "Arabisht",
      "French": "Frëngjisht",
      "German": "Gjermanisht",
      "Japanese": "Japonisht",
      "Portuguese": "Portugalisht"
    }
  },
  "templates": {
    "dialog_aria": "Zgjidh modelin",
    "header": "Zgjidh një Model",
    "builtInLabel": "I integruar",
    "myTemplatesLabel": "Modelet e Mia",
    "saveCurrent": "Ruaj shënimin aktual si model",
    "myTemplatesEmpty": "Modelet e tua të ruajtura do të shfaqen këtu",
    "useTemplate": "Përdor Modelin",
    "meeting": {
      "name": "Shënime Takimi",
      "description": "Kap vendimet dhe pikat e veprimit",
      "structure": "Pjesëmarrësit / Rendi i ditës / Shënimet / Veprimet"
    },
    "journal": {
      "name": "Ditar Ditor",
      "description": "Reflekto mbi ditën tënde",
      "structure": "Mirënjohja / Fitoret e sotme / Shënimet"
    },
    "book": {
      "name": "Përmbledhje Libri",
      "description": "Kap idetë kryesore nga një libër",
      "structure": "Ideja qendrore / Citimet kyçe / Mësimet"
    },
    "project": {
      "name": "Përshkrim Projekti",
      "description": "Përvijo qëllimin, synimet dhe palët e interesit",
      "structure": "Synimi / Qëllimi / Rreziqet / Afati kohor"
    },
    "brainstorm": {
      "name": "Stuhi idesh",
      "description": "Kapje e lirë idesh",
      "structure": "Tema / Idetë / Hapat e ardhshëm"
    },
    "weekly": {
      "name": "Rishikim Javor",
      "description": "Rishiko dhe planifiko javën tënde",
      "structure": "Fitoret / Vështirësitë / Fushat e fokusit"
    }
  },
  "voice": {
    "dialog_aria": "Regjistruesi i shënimit zanor",
    "cancel_aria": "Anulo",
    "statusRecording": "Duke regjistruar",
    "statusTranscribing": "Duke transkriptuar…",
    "statusReview": "Rishikim",
    "skip": "Kapërce",
    "mark": "Shëno",
    "mark_title": "Lësho një shenjë kohore",
    "captureMeeting": "Kap takimin",
    "captureMeeting_title": "Kap gjithashtu audion nga një skedë takimi",
    "meeting": "Takim",
    "meeting_title": "Duke kapur skedën e takimit",
    "markers_aria": "Shenjat kohore",
    "listening": "Duke dëgjuar…",
    "micDenied": "Qasja në mikrofon është e fikur. Lejojeni te Cilësimet dhe provoni sërish.",
    "captureFailed": "Regjistrimi nuk mundi të niste. Provoni sërish pas pak.",
    "tabPicker_aria": "Zgjidh një skedë takimi për të kapur",
    "captureFrom": "Kap audion nga…",
    "noAudibleTab": "Asnjë skedë nuk po luan audio. Hap takimin tënd dhe sigurohu që dikush po flet, pastaj provo sërish.",
    "tabPickerCancel": "Anulo",
    "tabTranscript": "Transkripti",
    "structuring": "Duke strukturuar…",
    "structuredNote": "Shënim i Strukturuar",
    "structureFailed": "Shënimi i strukturuar nuk u krijua dot.",
    "retryStructure": "Provo përsëri",
    "browserTranscript": "Transkripti i shfletuesit",
    "nothingCaptured": "Nuk u kap asgjë.",
    "buildingStructured": "Duke ndërtuar shënimin e strukturuar…",
    "cancel": "Anulo",
    "stop": "Ndalo",
    "recordAgain": "Regjistro sërish",
    "saveToNote": "Ruaj te Shënimi",
    "statusMeeting": "Mbledhje",
    "captureStrip_aria": "Po kapet audioja nga {{tab}}",
    "stopCapture": "Ndalo kapjen",
    "stopCapture_title": "Ndalon kapjen e skedës — mikrofoni vazhdon të regjistrojë",
    "stopsIn": "Ndalon pas {{time}}",
    "autoStopped": "Regjistrimi u ndal në kufirin 60-minutësh.",
    "autoStoppedQuota": "Regjistrimi u ndal — ke përdorur minutat e transkriptimit të këtij muaji.",
    "captureLost": "Skeda e mbledhjes u mbyll. Mikrofoni yt vazhdon të regjistrojë.",
    "tabSummary": "Përmbledhje",
    "noSpeakers": "Folësit nuk u identifikuan",
    "speakerN": "Folësi {{number}}",
    "renameSpeaker_aria": "Riemërto {{name}} — zbatohet për të gjitha rreshtat e tij",
    "renameSpeaker_input_aria": "Emri i folësit",
    "turnTime_title": "Thënë në {{time}}",
    "actionItemsTitle": "Detyra për veprim",
    "actionsCount": "{{checked}} nga {{total}}",
    "addToTasks_one": "Shto {{count}} te Detyrat",
    "addToTasks_other": "Shto {{count}} te Detyrat",
    "addToTasksZero": "Shto te Detyrat",
    "adding": "Duke shtuar…",
    "tasksAdded_one": "{{count}} detyrë u shtua",
    "tasksAdded_other": "{{count}} detyra u shtuan",
    "viewTasks": "Shiko",
    "addFailed": "Nuk u shtua dot — provo sërish.",
    "minutesLeft_one": "{{count}} min e mbetur",
    "minutesLeft_other": "{{count}} min të mbetura",
    "minutesLeftShort_one": "{{count}} min e mbetur",
    "minutesLeftShort_other": "{{count}} min të mbetura",
    "minutesLeft_title": "{{count}} minuta transkriptimi të mbetura këtë muaj",
    "quotaExhausted": "Ke përdorur minutat e mbledhjeve të këtij muaji. Rifreskohen më {{date}}.",
    "quotaUnknown": "Minutat e mbetura të panjohura — regjistrimi mund të arrijë kufirin mujor",
    "meetingProRequired": "Transkriptimi i mbledhjeve është pjesë e Pro-s. Transkripti yt i drejtpërdrejtë ruhet më poshtë.",
    "gateTitle": "Regjistrim mbledhjesh",
    "gateBody": "Regjistro skedën e një mbledhjeje bashkë me mikrofonin — me folës të identifikuar dhe detyra të nxjerra. E përfshirë me Pro.",
    "gateLater": "Jo tani",
    "gateCta": "Shiko Pro",
    "roomOption": "Pa skedë — regjistro dhomën",
    "roomHint": "Një telefonatë në altoparlant, një aplikacion i veçantë ose njerëz në dhomë — gjithçka që mund ta dëgjosh me zë.",
    "roomHint_title": "Nëse pala tjetër është në kufjet e tua, mikrofoni nuk mund ta dëgjojë — përdor altoparlantin.",
    "recordRoom": "Regjistro dhomën",
    "recordRoom_title": "Regjistro të gjithë ata që dëgjon mikrofoni — me folës të identifikuar",
    "roomStart": "Fillo",
    "statusRoom": "Dhoma",
    "roomStrip": "Po regjistrohet dhoma",
    "roomStrip_aria": "Po regjistrohet dhoma — të gjithë ata që dëgjon mikrofoni",
    "roomOff": "Fike",
    "roomOff_title": "Fik modalitetin e dhomës — kjo bëhet një shënim zanor i zakonshëm",
    "roomRenameHint": "Prek një emër për ta riemërtuar — njëri prej tyre je ti.",
    "gateBodyRoom": "Regjistro çfarë thuhet rreth teje — me folës të identifikuar dhe detyra të nxjerra. E përfshirë me Pro.",
    "roomHintDevice": "Telefonatat në këtë pajisje nuk mund të regjistrohen — iOS i mban private. Një telefon tjetër në altoparlant, ose një bisedë në dhomë, funksionon.",
    "autoStoppedSize": "Regjistrimi u ndal në kufirin e madhësisë së ngarkimit.",
    "tooLarge": "Regjistrimi ishte tepër i madh për t'u ngarkuar, ndaj nuk u transkriptua dot.",
    "destTo": "Në",
    "dest_aria": "Shto në listën: {{name}}",
    "destMenu_aria": "Zgjidh një listë",
    "destNewPending_aria": "Listë e re: {{name}}"
  },
  "meetingNotice": {
    "title": "Mbledhjet, në shënimet e tua",
    "body": "Rhemn tani mund të regjistrojë një skedë mbledhjeje që zgjedh ti — vetëm ndërsa regjistron një shënim zanor, dhe vetëm skedën që zgjedh.",
    "factPrivacy": "Audioja përpunohet për të krijuar transkriptin, pastaj hidhet. Regjistrimet nuk ruhen kurrë.",
    "factControl": "Asgjë nuk kapet derisa të shtypësh regjistrimin dhe të zgjedhësh një skedë.",
    "cta": "E kuptova",
    "privacyLink": "Lexo politikën tonë të privatësisë",
    "dialog_aria": "Rreth lejes së re të regjistrimit të mbledhjeve"
  }
}
